// extracted by mini-css-extract-plugin
module.exports = {"root":"MetadataForm_root__2D0xR"};